export const USER_LEAD_INFO_COLLECTION_KEY = "natomas/v1/user_lead";
export const USER_COLLECTION_KEY = "natomas/v1/user";
export const USER_PERMISSIONS_COLLECTION_KEY = "natomas/v1/permissions";
export const USER_ACTION_SUB_COLLECTION_KEY = "action";
